module.exports = __webpack_public_path__ + "static/media/townplanner2.38b2ee2f.png";